export class OrderTagPetItemModel {
    constructor() {
        this.printType = 0;
        this.printTypeName = "";
        this.barcode = 0;
        this.checked = false;
        this.artworkTypeName = ""
    }
}
